import './viz.css'

export interface FunnelStage {
  label: string
  count: number
  tone?: 'brand' | 'warn' | 'gain'
}

interface MiniFunnelProps {
  stages: FunnelStage[]
  ariaLabel: string
}

/** Stacked rows of bars sized relative to the largest stage. */
export function MiniFunnel({ stages, ariaLabel }: MiniFunnelProps) {
  const max = Math.max(0, ...stages.map((s) => (Number.isFinite(s.count) ? s.count : 0)))

  return (
    <div
      className="viz-funnel"
      role="img"
      aria-label={ariaLabel}
      style={{ ['--rows' as string]: Math.max(1, stages.length) }}
    >
      {stages.map((stage, i) => {
        const pct = max > 0 && Number.isFinite(stage.count) ? Math.max(0, (stage.count / max) * 100) : 0
        return (
          <div className="viz-funnel-row" key={`${stage.label}-${i}`}>
            <span className="viz-funnel-label">{stage.label}</span>
            <span
              className={`viz-funnel-bar viz-funnel-bar--${stage.tone ?? 'brand'}`}
              style={{ width: `${pct}%`, minWidth: '4px' }}
            />
            <span className="viz-funnel-count">{Number.isFinite(stage.count) ? stage.count : '—'}</span>
          </div>
        )
      })}
    </div>
  )
}
